<template>
	<div class="layout">
		<div class="div-title">
			<div class="div-title-label">
				基本信息
			</div>
		</div>
		<div class="div-content">
			<div class="div-content-left" @click="previewSkuImages(commodityData.imgFile)">
				<ImagePage :imageData='commodityData.imgFile'></ImagePage>
			</div>
			<div class="div-content-right">
				<div class="div-content-right-col">
					<div class="div-content-right-col-cell">
						商品名称：<span class="div-content-right-col-cell-span">{{commodityData.name}}</span>
					</div>
					<div class="div-content-right-col-cell text-overflow">
						商品规格：<span class="div-content-right-col-cell-span" :title="commodityData.format">{{commodityData.format}}</span>
					</div>
					<div class="div-content-right-col-cell">
						商品单位：<span class="div-content-right-col-cell-span">{{commodityData.unit}}</span>
					</div>
					<div class="div-content-right-col-cell">
						采购价格：<span class="div-content-right-col-cell-span">{{commodityData.intoPrice}}</span>
					</div>
					<div class="div-content-right-col-cell">
						批发价格：<span class="div-content-right-col-cell-span">{{commodityData.wholesalePricePrice}}</span>
					</div>
					<div class="div-content-right-col-cell">
						是否启用：<span class="div-content-right-col-cell-span">{{commodityData.isUse ? '是':'否'}}</span>
					</div>
					<div class="div-content-right-col-cell">
						库存预警：<span class="div-content-right-col-cell-span">{{commodityData.stockPrompt}}</span>
					</div>
				</div>
				<div class="div-content-right-col">
					<div class="div-content-right-col-cell">
						商品条码：<span class="div-content-right-col-cell-span">{{commodityData.code}}</span>
					</div>
					<div class="div-content-right-col-cell">
						商品种类：<span class="div-content-right-col-cell-span">{{commodityData.type}}</span>
					</div>
					<div class="div-content-right-col-cell">
						零售价格：<span class="div-content-right-col-cell-span">{{commodityData.retailPrice}}</span>
					</div>
					<div class="div-content-right-col-cell">
						库存：<span class="div-content-right-col-cell-span">{{commodityData.stock}}</span>
					</div>
					<div class="div-content-right-col-cell">
						启用批次：<span
							class="div-content-right-col-cell-span">{{commodityData.enableBatch ? '是':'否'}}</span>
					</div>
					<div class="div-content-right-col-cell">
						启用负库存：<span class="div-content-right-col-cell-span">{{commodityData.negativeStock? '是':'否'}}</span>
					</div>
					<div class="div-content-right-col-cell">
						备注：<span class="div-content-right-col-cell-span">{{commodityData.note}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="div-title">
			<div class="div-title-label">
				副计量单位
			</div>
		</div>
		<div class="div-content">
			<Table :columns="extraUnitColumns" :data="commodityData.extraUnits"></Table>
		</div>
		<div class="div-title">
			<div class="div-title-label">
				单品信息
			</div>
		</div>
		<div class="div-content">
			<Table stripe :columns="skuFormatTableColumns" :data="getSkuData" :span-method="handleSpan" border>
				<!-- 图片列插槽 - 使用图片上传预览子组件 -->
				<template slot-scope="{ row }" slot="imgFiles">
					<div style="text-align: center; padding: 8px;">
						<!-- 显示第一张图片 -->
						<div v-if="row.imgFiles && row.imgFiles.length > 0">
							<img :src="row.imgFiles[0].url"
								style="width: 80px; height: 80px; object-fit: cover; border-radius: 4px; cursor: pointer;"
								@click="previewSkuImages(row.imgFiles)" />
							<!-- 图片数量提示 -->
							<div v-if="row.imgFiles.length > 1" style="margin-top: 4px;">
								<Tag color="blue">
									<Icon type="md-images" /> {{ row.imgFiles.length }}张
								</Tag>
							</div>
						</div>
					</div>
				</template>
			</Table>
		</div>
		<div class="div-title">
			<div class="div-title-label">
				价格信息
			</div>
		</div>
		<div class="div-content">
			<div class="content-left-right-split" v-if="!commodityData.isDifferentPricing">
				<div class="div-content-right-col-cell" style="width: 32.5%;">
					采购价：<span class="div-content-right-col-cell-span">{{commodityData.intoPrice}}</span>
				</div>
				<div class="div-content-right-col-cell" style="width: 32.5%;">
					批发价：<span class="div-content-right-col-cell-span">{{commodityData.wholesalePricePrice}}</span>
				</div>
				<div class="div-content-right-col-cell" style="width: 32.5%;">
					零售价：<span class="div-content-right-col-cell-span">{{commodityData.retailPrice}}</span>
				</div>
			</div>
			<div v-else>
				<Table stripe :columns="skuPriceTableColumns" :data="getSkuData" :span-method="handleSpan2"
					border />
			</div>
		</div>
		<!-- 使用封装的图片预览子组件 -->
		<ImagePreview ref="imagePreview" :images="previewImagesList" :visible.sync="previewVisible"
			:initial-index="currentImageIndex" @change="onPreviewImageChange" />
	</div>
</template>

<script>
	import request from '@/utils/request'
	import ImagePage from '@/components/ImagePage'
	import ImagePreview from '@/components/ImagePreview' // 导入图片预览子组件
	export default {
		name: 'commoditydetailinfo',
		components: {
			ImagePage,
			ImagePreview
		},
		computed: {
			getSkuData() {
				let array = [];
				this.commodityData.commodityPriceTypeGroups.forEach((item, index) => {
					item.commodityPriceTypes.forEach((item2, index2) => {
						array.push({
							_index: index, // 用于标识行索引
							index: array.length + 1,
							code: item2.code,
							groupIndex: index,
							priceTypeIndex: index2,
							imgFiles: item.imgFiles ? item.imgFiles : [],
							groupName: item.groupName,
							priceType: item2.priceType,
							intoPrice: item2.intoPrice,
							wholesalePricePrice: item2.wholesalePricePrice,
							retailPrice: item2.retailPrice,
						})
					});
				});
				this.$nextTick(() => {
					this.calculateSpan();
				});
				return array;
			}
		},
		data() {
			return {
				commodityId: 0,
				commodityData: {
					id: 0,
					code: '',
					name: '',
					imgFile: [],
					type: '',
					unit: '',
					format: '',
					intoPrice: '',
					wholesalePricePrice: '',
					retailPrice: '',
					enableBatch: false,
					stockPrompt: '',
					isMultiMetering: false,
					negativeStock : false,
					extraUnits: [],
					isDifferentPricing: false,
					stock: 0,
					commodityInventorys: [],
					commodityPriceTypeGroups: [],
					note: '',
					creator: 0,
					isUse: true
				},
				extraUnitColumns: [{
						title: '序号',
						key: 'index',
						width: 80,
						align: 'center',
						render: (h, params) => {
							return h('span', params.index + 1);
						}
					},
					{
						title: '单位',
						key: 'unit',
						width: 150
					},
					{
						title: '换算率',
						key: 'conversionRate'
					},
					{
						title: '换算库存',
						key: 'conversionStock'
					},
					{
						title: '备注',
						key: 'note',
						width: 300
					}
				],
				skuFormatTableColumns: [{
						title: '序号',
						key: 'index',
						width: 80,
						align: 'center',
						render: (h, params) => {
							return h('span', params.index + 1);
						}
					},
					{
						title: '图片',
						key: 'imgFiles',
						align: 'center',
						slot: 'imgFiles' // 使用自定义插槽
					},
					{
						title: '群组',
						key: 'groupName',
						align: 'center'
					},
					{
						title: '条码',
						key: 'code',
						align: 'center',
						render: (h, params) => {
							return h('span', params.row.code ? params.row.code : '无');
						}
					},
					{
						title: '规格',
						key: 'priceType',
						width: 400,
						align: 'left'
					}
				],
				skuPriceTableColumns: [{
						title: '序号',
						key: 'index',
						width: 80,
						align: 'center',
						render: (h, params) => {
							return h('span', params.index + 1);
						}
					},
					{
						title: '群组',
						key: 'groupName',
						width: 180,
						align: 'center'
					},
					{
						title: '规格',
						key: 'priceType',
						width: 300,
						align: 'left'
					},
					{
						title: '采购价',
						key: 'intoPrice',
						align: 'left',
						render: (h, params) => {
							return h('span', {}, params.row.intoPrice+'元');
						}
					},
					{
						title: '批发价',
						key: 'wholesalePricePrice',
						align: 'left',
						render: (h, params) => {
							return h('span', {}, params.row.wholesalePricePrice+'元');
						}
					},
					{
						title: '零售价',
						key: 'retailPrice',
						align: 'left',
						render: (h, params) => {
							return h('span', {}, params.row.retailPrice+'元');
						}
					}
				],
				// 图片预览相关 - 简化后的变量
				previewVisible: false,
				previewImagesList: [],
				currentImageIndex: 0,
				spanArr: []
			}
		},
		methods: {
			initCommodityInfo(id) {
				let self = this;
				request.get('/api/Commodity/GetCommodity', {
					params: {
						id: id
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取商品数据失败：" + response.errorMsg
						});
						return;
					}
					self.commodityData = response.data;
				}).catch(function(error) {})
			},
			calculateSpan() {
				this.spanArr = [];
				let pos = 0;

				for (let i = 0; i < this.getSkuData.length; i++) {
					if (i === 0) {
						this.spanArr.push(1);
						pos = 0;
						continue;
					}

					if (this.getSkuData[i].groupName === this.getSkuData[i - 1].groupName) {
						this.spanArr[pos] += 1;
						this.spanArr.push(0);
					} else {
						this.spanArr.push(1);
						pos = i;
					}
				}
			},
			handleSpan({
				rowIndex,
				columnIndex
			}) {
				// 对于每一列都要返回合并配置

				// 1. 图片列 (columnIndex = 1)
				if (columnIndex === 1) {
					const rowspan = this.spanArr[rowIndex];
					const colspan = 1;

					// 如果rowspan为0，表示该单元格应该被隐藏
					if (rowspan === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}

					// 否则返回正常的合并配置
					return {
						rowspan: rowspan,
						colspan: colspan
					};
				}

				// 2. 分组列 (columnIndex = 2)
				if (columnIndex === 2) {
					const rowspan = this.spanArr[rowIndex];
					const colspan = 1;

					if (rowspan === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}

					return {
						rowspan: rowspan,
						colspan: colspan
					};
				}

				// 3. 其他列（序号和SKU名称）不需要合并，返回默认配置
				return {
					rowspan: 1,
					colspan: 1
				};
			},
			handleSpan2({
				rowIndex,
				columnIndex
			}) {
				// 2. 分组列 (columnIndex = 2)
				if (columnIndex === 1) {
					const rowspan = this.spanArr[rowIndex];
					const colspan = 1;

					if (rowspan === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}

					return {
						rowspan: rowspan,
						colspan: colspan
					};
				}

				// 3. 其他列（序号和SKU名称）不需要合并，返回默认配置
				return {
					rowspan: 1,
					colspan: 1
				};
			},
			/**
			 * 预览SKU图片 - 简化版本，使用子组件
			 */
			previewSkuImages(images) {
				if (!images || images.length === 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "暂无图片"
					});
					return;
				}

				this.previewImagesList = images;
				this.currentImageIndex = 0;
				this.previewVisible = true;
			},

			/**
			 * 图片切换事件
			 */
			onPreviewImageChange(index, image) {
				this.currentImageIndex = index;
			},

		},
		watch: {
			'$route.query.commodityId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.initCommodityInfo(param);
					}
				}
			}
		},
		created: function() {}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	.div-title {
		padding: 10px 0px;
		border-bottom: 1px solid #ebeef5;
	}

	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}

	.div-content {
		overflow: hidden;
		padding-top: 20px;
		margin-bottom: 20px;
	}

	.div-content-left {
		float: left;
		width: 30%;
	}

	.div-content-left-image {
		margin-top: 20px;
	}

	.div-content-left-image img {
		width: 300px;
		height: 300px;
	}

	.div-content-left-image-index {
		overflow: hidden;
		width: 300px;
	}

	.div-content-left-image-index-left {
		float: left;
		width: 6%;
		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}

	.div-content-left-image-index-left:hover {
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}

	.div-content-left-image-index-center {
		float: left;
		width: 88%;
		overflow-y: auto;
		padding: 0px 4px;
	}

	.div-content-left-image-index-center img {
		width: 44px;
		height: 44px;
		cursor: pointer;
		margin-right: 4px;
	}

	.selected-image {
		border: rgb(255, 106, 127) 1px solid;
	}

	.div-content-left-image-index-right {
		float: right;
		width: 6%;
		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}

	.div-content-left-image-index-right:hover {
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}

	.div-content-right {
		float: left;
		width: 70%;
		overflow: hidden;
	}

	.div-content-right-col {
		float: left;
		width: 50%;
	}

	.div-content-right-col-cell {
		padding: 15px;
	}

	.div-content-right-col-cell-span {
		color: black;
	}
</style>